import { render, staticRenderFns } from "./SupplierProductItemInfo.vue?vue&type=template&id=018edff5"
import script from "./SupplierProductItemInfo.vue?vue&type=script&lang=js"
export * from "./SupplierProductItemInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports